import React from 'react';
import * as PropTypes from 'prop-types';

import ErrorBlock from '../../../common/ErrorBlock';
import ProgressBar from './ProgressBar';
import Paper from '../../../Paper';
import Button from '../../../Button';
import styles from './styles.styl';

function Progress({ progress, formatMessage, onClick, disabled, error }) {
  return (
    <Paper className={styles.root}>
      <h5 className={styles.title}>
        {formatMessage({ id: 'virtualVisit.test.progress' })}
      </h5>
      <ProgressBar progress={progress} withTransition />
      {error && (
        <ErrorBlock className="mt2" errors={formatMessage({ id: error })} />
      )}
      <Button
        className={styles.btn}
        type="button"
        color="primary"
        raised
        onClick={onClick}
        disabled={disabled}
      >
        {formatMessage({ id: 'virtualVisit.test.cancel' })}
      </Button>
    </Paper>
  );
}

Progress.propTypes = {
  progress: PropTypes.number,
  formatMessage: PropTypes.func,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  error: PropTypes.string,
};

export default Progress;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoTest/Components/Progress/index.jsx